import { useLingui } from '@lingui/react/macro'

import { UserForm } from '@/features/user'
import { DialogHeader } from '@/layouts/Dialog'

export default function Profile() {
  const { t } = useLingui()

  return (
    <div className="flex flex-col p-8">
      <DialogHeader
        title={t`Your Profile`}
        description={t`Settings for your user profile`}
      />
      <UserForm />
    </div>
  )
}
